import { render, staticRenderFns } from "./login_vn.vue?vue&type=template&id=fef687ea&"
import script from "./login_vn.vue?vue&type=script&lang=js&"
export * from "./login_vn.vue?vue&type=script&lang=js&"
import style0 from "./login_vn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports